// src/utils/blasphemyFilter.js
// Rilevamento bestemmie italiane per i nomi delle squadre in fase di creazione asta.
// Obiettivo: bloccare le combinazioni "termine religioso + offesa" (es. "dio cane",
// "porco dio", "porca madonna", "diocane", "porcodio") mantenendo alta precisione,
// così da non bocciare nomi legittimi che contengono sottostringhe innocue
// (es. "Radio Cane", "Stadio", "Savoia", "Madonna" da sola).

// Radici religiose (con eventuale doppia consonante / desinenze comuni).
const REL = '(?:dd?io|iddio|madonn[ae]|cristo|gesu(?:cristo)?|osti[ae]|sacrament[oi]|padreterno|eucar(?:estia|istia)|vergine)';

// Radici offensive con desinenze comuni.
const OFF = '(?:porc[oaie]|maial[eai]|can[ei]|boi[ao]|merd[aei]|troi[ae]|puttan[aoei]|zoccol[ae]|bastard[oiae]|stronz[oiae]|cornut[oiae]|schifos[oiae]|ladr[oiae]|infam[ei]|besti[ae]|sderenat[oiae]|lurid[oiae]|maledett[oiae])';

// Forma "a parole staccate": offesa e termine religioso adiacenti (in un ordine o
// nell'altro). I confini di parola evitano i falsi positivi ("radio cane" → "dio"
// dentro "radio" non ha confine di parola e non scatta).
const SPACED_RE = new RegExp(`\\b(?:${OFF}\\s+${REL}|${REL}\\s+${OFF})\\b`, 'i');

// Forma "fusa" in un unico token: il token deve INIZIARE con la coppia
// religioso+offesa (in un ordine o nell'altro), così "diocane"/"porcodio" scattano
// ma "radiocane"/"stadio"/"custodia" no.
const FUSED_RE = new RegExp(`^(?:${OFF}${REL}|${REL}${OFF})`, 'i');

function normalize(value = '') {
  return String(value)
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')   // rimuove i diacritici
    .replace(/[^a-z\s]/g, ' ')         // tiene solo lettere e spazi
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * Ritorna true se il testo contiene una bestemmia riconoscibile.
 * @param {string} value
 * @returns {boolean}
 */
export function containsBlasphemy(value = '') {
  const norm = normalize(value);
  if (!norm) return false;

  if (SPACED_RE.test(norm)) return true;

  return norm.split(' ').some((token) => FUSED_RE.test(token));
}

export default containsBlasphemy;
